/** AUTO GENERATED FROM "node ./src/utils/convert-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" className={classNames('nmx-icon', className)} ref={svgRef} {...otherProps}>
        <defs>
          <mask id="bc4292cd-19c9-4ffe-a19d-b86395f01b67" x="0" y="0" width="24" height="24" maskUnits="userSpaceOnUse">
            <path d="M13.58,3H5V22H18.8V8.19L13.62,3ZM17.8,21H6V4h6.88V8.9H17.8Zm-5.75-3.29v1H7.6v-1Zm4.15-3.26v1H7.6v-1Zm0-3.28v1H7.6v-1ZM13.88,4.7l3.2,3.2H13.87Z" fill="#fff" fillRule="evenodd"/>
          </mask>
        </defs>
        <path d="M13.58,3H5V22H18.8V8.19L13.62,3ZM17.8,21H6V4h6.88V8.9H17.8Zm-5.75-3.29v1H7.6v-1Zm4.15-3.26v1H7.6v-1Zm0-3.28v1H7.6v-1ZM13.88,4.7l3.2,3.2H13.87Z" style={{ fill: '#05273e' }}/><g style={{ mask: 'url(#bc4292cd-19c9-4ffe-a19d-b86395f01b67)' }}>
          <path d="M0,0H24V24H0Z" fill="#4a4a4a" className="icon-fill" fillRule="evenodd"/>
        </g><g style={{ mask: 'url(#bc4292cd-19c9-4ffe-a19d-b86395f01b67)' }}>
          <path d="M0,0H24V24H0Z" fill="#4a4a4a" className="icon-fill" fillRule="evenodd"/>
        </g>
      </svg>

    );
  }
}

Icon.displayName = 'PaperFoldedCornerIcon';

export default Icon;
